import ArrowFollow, { DIRECTION, HORIZONTAL, VERTICAL, ICorner, IDirection, CORNER } from './ArrowFollow';
export type { ICorner, IDirection };

/**
 * @deprecated Change for: "DIRECTION"
 */
const POSITION = DIRECTION;

export { ArrowFollow, DIRECTION, HORIZONTAL, VERTICAL, CORNER, POSITION };
export default ArrowFollow;
